import { DocumentGeneric } from 'dashboard/models/document';
import { Tag } from 'dashboard/models/tag';
import { User } from 'dashboard/models/user';
import { Verification } from 'dashboard/models/verification';
import Action from 'lib/interfaces/Action';

export type VerificationActions =
  | Action<VerificationActionType.ClearVerification>
  | Action<VerificationActionType.SetVerification, SetVerificationPayload>
  | Action<VerificationActionType.SetVerificationDetails, SetVerificationDetailsPayload>;

export enum VerificationActionType {
  ClearVerification = 'verification/CLEAR_VERIFICATION',
  SetVerification = 'verification/SET_VERIFICATION',
  SetVerificationDetails = 'inquiry/SET_VERIFICATION_DETAILS',
}

export function clearVerification(): Action<VerificationActionType.ClearVerification> {
  return { type: VerificationActionType.ClearVerification };
}

interface SetVerificationPayload {
  verification: Verification;
}

export function setVerification(
  verification: Verification,
): Action<VerificationActionType.SetVerification, SetVerificationPayload> {
  return {
    payload: {
      verification,
    },
    type: VerificationActionType.SetVerification,
  };
}

interface SetVerificationDetailsPayload {
  redactor: User | undefined;
  tags: Tag[];
  document: DocumentGeneric;
}

export function setVerificationDetails({
  redactor,
  tags,
  document,
}: SetVerificationDetailsPayload): Action<
  VerificationActionType.SetVerificationDetails,
  SetVerificationDetailsPayload
> {
  return {
    payload: {
      redactor,
      tags,
      document,
    },
    type: VerificationActionType.SetVerificationDetails,
  };
}
